<template>
  <div class="editor-block-tabs flex flex-col">
    <div
      class="editor-block-tabs-item"
      :class="{ active: displayType === 'editor' }"
      @click="clickTab('editor')"
    >
      <img
        :src="
          displayType === 'editor'
            ? themeIconData.editor.active
            : themeIconData.editor.default
        "
        alt=""
      />
      <span>简历编辑</span>
    </div>
    <div
      class="editor-block-tabs-item"
      :class="{ active: displayType === 'template' }"
      @click="clickTab('template')"
    >
      <img
        :src="
          displayType === 'template'
            ? themeIconData.template.active
            : themeIconData.template.default
        "
        alt=""
      />
      <!-- <img
        v-if="themeIconData.template.topRightIcon"
        :src="themeIconData.template.topRightIcon"
        alt=""
        class="top-right-icon"
      /> -->
      <span>简历模版</span>
    </div>
    <!-- <div
      class="editor-block-tabs-item"
      :class="{ active: displayType === 'interview' }"
      @click="clickTab('interview')"
    >
      <img
        :src="
          displayType === 'interview'
            ? themeIconData.interview.active
            : themeIconData.interview.default
        "
        alt=""
      />
      <span>模拟面试</span>
    </div> -->
    <!-- <div
      class="editor-block-tabs-item"
      :class="{ active: displayType === 'aiMentor' }"
      @click="clickTab('aiMentor')"
    >
      <img
        :src="
          displayType === 'aiMentor'
            ? themeIconData.mentor.active
            : themeIconData.mentor.default
        "
        alt=""
      />
      <span>AI导师</span>
    </div> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
const darkIconData = {
  editor: {
    default: "https://logo.wondercv.com/banners/IunBZIDFYDvBvEe.png",
    active: "https://logo.wondercv.com/banners/3gd3ubVZc9IHXXQ.png",
  },
  template: {
    default: "https://logo.wondercv.com/banners/GhEMy6yd6J6owH7.png",
    active: "https://logo.wondercv.com/banners/hLZzEonbsahetCR.png",
    topRightIcon: "https://logo.wondercv.com/banners/a1yNJEa628dTDhH.png",
  },
  mentor: {
    default: "https://logo.wondercv.com/banners/oROEFCzUHfyYRNl.png",
    active: "https://logo.wondercv.com/banners/RvTkotSv4yJctWl.png",
  },
  job: {
    default: "https://logo.wondercv.com/banners/dZc4ihFgBW4dBfO.png",
    active: "https://logo.wondercv.com/banners/cFsPzx9SbcWjxN1.png",
  },
  interview: {
    default: "https://logo.wondercv.com/banners/pB0qYAZJxT2p2YS.png",
    active: "https://logo.wondercv.com/banners/6hBABjOKvz2S7ix.png",
  },
};
const lightIconData = {
  editor: {
    default: "https://logo.wondercv.com/banners/WJtFyAssKMPBvcc.png",
    active: "https://logo.wondercv.com/banners/6xx50e0G3tXQb0t.png",
  },
  template: {
    default: "https://logo.wondercv.com/banners/DZDYfAqNHC6m2a3.png",
    active: "https://logo.wondercv.com/banners/VXQtXbJEM0zL8uI.png",
    topRightIcon: "https://logo.wondercv.com/banners/a1yNJEa628dTDhH.png",
  },
  mentor: {
    default: "https://logo.wondercv.com/banners/0nDU7YRvNcrnJ71.png",
    active: "https://logo.wondercv.com/banners/e6ltNPR51JlCV1I.png",
  },
  job: {
    default: "https://logo.wondercv.com/banners/wuF1heHfLlXf9AZ.png",
    active: "https://logo.wondercv.com/banners/N9rUNf2LIYeWt53.png",
  },
  interview: {
    default: "https://logo.wondercv.com/banners/fCL4W2ASYtuaz9t.png",
    active: "https://logo.wondercv.com/banners/xfDYgz4VwbgXjXi.png",
  },
};
export default {
  name: "EditorBlockTabs",
  props: {
    displayType: {
      type: String,
      default: "editor",
    },
  },
  computed: {
    ...mapState("me", ["personInfo"]),
    themeIconData() {
      const { theme } = this.personInfo;
      return theme === "dark" ? darkIconData : lightIconData;
    },
  },
  methods: {
    clickTab(type) {
      this.$emit("clickTab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.editor-block-tabs-item {
  @apply flex flex-col justify-center items-center cursor-pointer relative;
  width: 92px;
  height: 77px;
  border-radius: 0px 12px 12px 0px;
  color: $editor-tab-default-color;
  img {
    width: 24px;
    height: 24px;
    margin-bottom: 10px;
    &.top-right-icon {
      position: absolute;
      top: -2px;
      right: -14px;
      height: 16px;
      width: auto;
      margin-bottom: 0;
    }
  }
  &.active {
    background-color: $editor-tab-bg-active-color;
    span {
      background: linear-gradient(
        to right,
        $editor-tab-text-color-start 0%,
        $editor-tab-text-color-end 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
</style>
